// extracted by mini-css-extract-plugin
export var sampleProjects = "sampleProjects-module--sampleProjects--3PHQb";
export var projectSlideShowContainer = "sampleProjects-module--projectSlideShowContainer--1q3PK";
export var projectSlideShow = "sampleProjects-module--projectSlideShow--v8D2G";
export var projectSlide = "sampleProjects-module--projectSlide--2AF2V";
export var description = "sampleProjects-module--description--vAxFD";
export var imageSection = "sampleProjects-module--imageSection--_8Axw";
export var projImage = "sampleProjects-module--projImage--2UXcx";
export var left = "sampleProjects-module--left--SiE9B";
export var right = "sampleProjects-module--right--2bFYc";
export var slideBeads = "sampleProjects-module--slideBeads--3diNj";
export var active = "sampleProjects-module--active--1bAXt";